import React from "react";
import styled from "styled-components";
import { GetIcon } from "../../../icons";

const CheckboxWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
`;

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const CheckboxCheckmark = styled.span`
  position: relative;
  display: flex;
  width: 24px;
  height: 24px;
  border: 2px solid #d6e0ff;
  border-radius: 3px;
  margin-right: 8px;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${(props) => (props.checked ? props.theme.background : "transparent")};
  color: ${(props) => (props.checked ? props.theme.checked : "transparent")};
  & svg{
    margin-right: 0px !important;
  }
  &.medium {
    width: 15px;
    height: 15px;
    svg {
      font-size: 12px;
      
    }
  }
  &.signupForm{
    width: 14px;
    height: 14px;
  }
  &.contact{
    width: 16px;
    height: 16px;
    background-color: #FFFFFF;
  }
`;
const CheckboxLabel = styled.label`
  font-size: 16px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  &.signupForm{
    align-items: flex-start;
    font-size: 14px;
    color: #292358;
  }
`;

const CheckboxSpan = styled.span`
  width: fit-content;
  margin-left: 10px;
  &.signupForm{
    width: 100%;
    margin: 0;
  }
  white-space: pre-wrap;
`;

const Checkbox = ({ label, checked, onChange, theme, className }) => {
  return (
    <CheckboxWrapper className={className}>
      <CheckboxLabel className={className}>
        <CheckboxInput className={className} type="checkbox" checked={checked} onChange={onChange} />
        <CheckboxCheckmark className={className} theme={theme} checked={checked}>
          {checked && <GetIcon icon={"checked"} />}
        </CheckboxCheckmark>
        <CheckboxSpan className={className} dangerouslySetInnerHTML={{ __html: label }}></CheckboxSpan>
        {/* {label} */}
      </CheckboxLabel>
    </CheckboxWrapper>
  );
};

export default Checkbox;
